/*! ******************************************************************************************************** *
 *
 * Copyright 2011-2020 Markus Schütz
 * Copyright 2025 Oidis
 *
 * SPDX-License-Identifier: BSD-2-Clause
 * The BSD-2-Clause license for this file can be found in the LICENSE.txt file included with this distribution
 * or at https://spdx.org/licenses/BSD-2-Clause.html#licenseText
 *
 * ********************************************************************************************************* */

export const KeyCodes = {

    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    BOTTOM: 40,
    DELETE: 46,

    A: "A".charCodeAt(0),
    S: "S".charCodeAt(0),
    D: "D".charCodeAt(0),
    W: "W".charCodeAt(0),
    Q: "Q".charCodeAt(0),
    E: "E".charCodeAt(0),
    R: "R".charCodeAt(0),
    F: "F".charCodeAt(0)

};
